
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "app-screen": "app-screen-78ec0afb",
    "appScreen": "app-screen-78ec0afb"
};
exports.styleSource = ".app-screen-78ec0afb{position:relative}";
exports.default = exports.styles;
            
module.moduleType = "style";
